import MuiAutocomplete from './MuiAutocomplete';
import MuiAvatar from './MuiAvatar';
import MuiButton from './MuiButton';
import MuiCard from './MuiCard';
import MuiCheckbox from './MuiCheckbox';
import MuiChip from './MuiChip';
import { MuiDialog, MuiDialogContent, MuiDialogActions } from './MuiDialog';
import MuiDivider from './MuiDivider';
import MuiCardContent from './MuiCardContent';
import MuiCardHeader from './MuiCardHeader';
import MuiFilledInput from './MuiFilledInput';
import MuiFormControl from './MuiFormControl';
import MuiFormHelperText from './MuiFormHelperText';
import MuiFormLabel from './MuiFormLabel';
import MuiInputBase from './MuiInputBase';
import MuiInputLabel from './MuiInputLabel';
import MuiInputAdornment from './MuiInputAdornment';
import {
  MuiList,
  MuiListItem,
  MuiListItemIcon,
  MuiListItemSecondaryAction,
  MuiListItemText,
} from './MuiListItem';
import MuiMenu from './MuiMenu';
import MuiSvgIcon from './MuiSvgIcon';
import { MuiTableCell } from './MuiTableCell';

const overrides = {
  MuiAutocomplete,
  MuiAvatar,
  MuiButton,
  MuiCard,
  MuiCheckbox,
  MuiChip,
  MuiDialog,
  MuiDivider,
  MuiDialogContent,
  MuiDialogActions,
  MuiCardContent,
  MuiCardHeader,
  MuiFilledInput,
  MuiFormControl,
  MuiFormHelperText,
  MuiFormLabel,
  MuiInputBase,
  MuiInputLabel,
  MuiInputAdornment,
  MuiList,
  MuiListItem,
  MuiListItemIcon,
  MuiListItemSecondaryAction,
  MuiListItemText,
  MuiMenu,
  MuiSvgIcon,
  MuiTableCell,
};

export default overrides;
